import { TripHistoryType } from 'models/trip-history.model';
import React from 'react';
import { getSimpleDateFormat } from 'utils/functions';

type Props = {
  tripDetails: TripHistoryType;
};

const TripHistoryCardFooter = ({ tripDetails }: Props) => {
  const dateObj = new Date(tripDetails.date);
  const time = tripDetails.date
    ? dateObj.toLocaleString('en-NG', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      })
    : '-';
  return (
    <div className='border-t border-gray-border text-xs p-4 '>
      <div className='flex items-center justify-center gap-2'>
        {tripDetails.date ? getSimpleDateFormat(tripDetails.date) : '-'}
        <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
        {time}
      </div>

      {/* <p className='text-red-5 capitalize'>Deductions: {tripDetails.deductions}</p> */}
    </div>
  );
};

export default TripHistoryCardFooter;
